module.exports = __webpack_public_path__ + "static/img/6-1.f431e67.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/home/imgs/6-1.png
// module id = m44j
// module chunks = 1